import { httpGet, httpPut, httpPost, httpDownload } from '../../../../util/request.js';
import appConfig from "@/config";

export default class StaffingApi {
    static list(param) {
        return this.httpRequest('/set/list', param, 'post');
    }

    static getStaffing(param){
        return this.httpRequest('/get', param, 'get');
    }

    static addStaffing(param){
        return this.httpRequest('/add', param, 'post');
   }

    static baseUrl = appConfig.gatewayUrl + appConfig.pdServicePath  + "/wb/staffing";
    //static baseUrl = "http://localhost:20065/pd-service" + "/wb/staffing";
    //static baseUrl = "https://ssl.springland.com.cn/pd-service" + "/wb/pd-wb-budget-type/";

    static httpRequest(url, param, method) {
        if (method == 'get') {
            return httpGet(this.baseUrl + url, param);
        }
        if (method == 'post') {
            return httpPost(this.baseUrl + url, param);
        }
        if (method == 'put') {
            return httpPut(this.baseUrl + url, param);
        }
        if (method == 'download') {
            return httpDownload(this.baseUrl + url, param);
        }
    }

    static handleResponse(response, scope, successFunc, errorFunc) {
        let data = response.data;
        if (data.code == 200) {
            if (successFunc && typeof successFunc == 'function') {
                successFunc(data.data);
            }
        } else {
            let text = data.errMsg
            scope.$dialog.error({
                text: text,
                title: "错误"
            });
            if (errorFunc && typeof errorFunc == 'function') {
                errorFunc(data);
            }
        }
    }

    static handleNetworkError(response, scope, errorFunc) {
        scope.$dialog.error({
            text: response.message,
            title: "错误"
        });
        if (errorFunc && typeof errorFunc == 'function') {
            errorFunc(response);
        }
    }




}